<template>
  <div v-loading="isLoading">
    <highcharts class="chart" :options="options" ref="highchart" />
  </div>
</template>

<script>
import {
  mapGetters
} from 'vuex';
import {
  isNil,
  cloneDeep
} from 'lodash';
import moment from 'moment';
import {
  stackedColumnOptions
} from '@/constants/chart-options';
import {
  treeType,
  treeNodeType,
  treeNodeSubType
} from '@/constants/tree';
import EventHistAPI from '@/api/event/event-hist';

export default {
  name: 'WEventHistStackedColumnChart',
  props: {
    active: Boolean,
    filterParams: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      options: cloneDeep(stackedColumnOptions),
      isLoading: false,
    };
  },
  computed: {
    selectedTreeType() {
      return this.$store.state.router.treeType;
    },
    ...mapGetters(['selectedNode', 'analysisDateParams', 'activeTab']),
  },
  watch: {
    selectedNode: {
      immediate: true,
      handler() {
        this.loadData();
        this.troubleShootingBtnFlag = true;
        this.selectedRowArray = []; // node 변경 시 선택한 row들이 담긴 배열 초기화
      },
    },
    active: {
      handler(value) {
        if (!isNil(value) && value) {
          this.options.chart.height = 150;
          this.loadData();
        }
      },
    },
    analysisDateParams: {
      immediate: true,
      handler(dateParams) {
        let diff = 0;
        if (!isNil(dateParams)) {
          const startDatetime = moment(dateParams.startDatetime);
          const endDatetime = moment(dateParams.endDatetime);
          diff = endDatetime.diff(startDatetime, 'hours');
        }
        let labelFormat = '{value: %Y-%m-%d}';
        let interval = null;
        let tooltipFormat = '%Y-%m-%d';
        if (diff < 1) {
          labelFormat = '{value: %H:%M}';
          tooltipFormat += ' %H:%M';
        } else if (diff > 0 && diff <= 24) {
          labelFormat = '{value: %H시}';
          interval = 3600 * 1000;
          tooltipFormat += ' %H시';
        }
        this.options.xAxis.tickInterval = interval;
        Object.assign(this.options.xAxis.labels, {
          format: labelFormat,
        });
        this.options.tooltip.xDateFormat = tooltipFormat;

        this.loadData();
      },
    },
    filterParams() {
      this.loadData();
    },
  },
  methods: {
    loadData() {
      if (isNil(this.active) || !this.active || isNil(this.selectedNode) || isNil(this.selectedNode.type)) {
        return;
      }
      this.isLoading = true;
      const params = {
        treeType: this.selectedTreeType,
        type: this.selectedNode.type,
        startDatetime: this.analysisDateParams.startDatetime,
        endDatetime: this.analysisDateParams.endDatetime,
        filterParams: this.filterParams,
      };

      const selectedTreeType = this.selectedTreeType;
      const selectedNode = this.selectedNode;
      if (selectedTreeType === treeType.PHYSICAL) {
        if (selectedNode.type === treeNodeType.GROUP) {
          params.managetypeId = this.selectedNode.managetypeId;
          params.objtypeId = this.selectedNode.objtypeId;
          // nms일 경우
          params.objCompanyId = this.selectedNode.objCompanyId;
          // vms일 경우
          params.hypervisorType = this.selectedNode.hypervisorType;
          params.virtualcenterGroupId = this.selectedNode.virtualcenterGroupId;
          params.objId = this.selectedNode.objId;
          params.subType = this.selectedNode.subType;
        } else if (selectedNode.type === treeNodeType.OBJ) {
          params.objId = this.selectedNode.obj.objId;
        }
      } else if (selectedNode.type === treeNodeType.GROUP) {
        if (selectedNode.subType === treeNodeSubType.VIRTUAL) {
          params.objId = this.selectedNode.objId;
          params.objtypeId = this.selectedNode.obj.objtypeId;
          params.subType = this.selectedNode.subType;
        } else if (selectedNode.subType === treeNodeSubType.APM) {
          params.tierId = selectedNode.tierId;
          params.subType = selectedNode.subType;
        } else {
          params.managegroupIds = this.selectedNode.childManagegroupIds;
        }
      } else if (selectedNode.type === treeNodeType.OBJ) {
        params.objId = this.selectedNode.obj.objId;
      }

      EventHistAPI.getEventHistChartData(params).then((response) => {
        this.options.series = response.data.data;
      }).finally(() => {
        this.isLoading = false;
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/event/event-hist/components/EventHistStackedColumnChart.vue